const { useState } = wp.element;

function PaginationComponent(props) {
  const pageNumbers = [];
  let getPageNumbers = () => {
    if (props.totalPages !== null) {
      for (let i = 1; i <= props.totalPages; i++) {
        pageNumbers.push(i);
      }
    }
  };
  getPageNumbers();

  let paginationClick = (event) => {
    props.channelPaginationCallback(event.target.innerHTML);
  };

  let renderPageNumbers = pageNumbers.map((number) => {
    let currentPage = props.channelCurrentPage;
    let classes = currentPage == number ? "pagination-number active" : "pagination-number";

    return (
      <span key={number} className={classes} onClick={(event) => paginationClick(event)}>
        {number}
      </span>
    );
  });
  return <div className="react-main-pagination-wrapper">{renderPageNumbers}</div>;
}

export default PaginationComponent;



// WEBPACK FOOTER //
// ./react/components/pagination/pagination-component.jsx